import { render, staticRenderFns } from "./real-estate-basic.vue?vue&type=template&id=5422efe8&scoped=true&"
import script from "./real-estate-basic.vue?vue&type=script&lang=js&"
export * from "./real-estate-basic.vue?vue&type=script&lang=js&"
import style0 from "./real-estate-basic.vue?vue&type=style&index=0&id=5422efe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5422efe8",
  null
  
)

export default component.exports